import React, {useRef} from 'react';
import { Brands } from '../util/constants';
import PriceWrapper from './shared/price-wrapper';

const MapTooltipItem = ({ item }) => {
  const { 
    company, 
    imageUrl, 
    name, 
    url, 
    cityStateZip,
    startingPrice,
    isFHA,
    isMortCalcEnabled,
    zipCode,
    downPaymentPercentage,
    hoaDues,
    phone,
    priceOverrideText
  } = item;

  const ccsLogo = require('../../../Century.Website/wwwroot/Assets/icons/community-cards-new/CCS_MapPin.svg')
  const cmpLogo = require('../../../Century.Website/wwwroot/Assets/icons/community-cards-new/CMP_MapPin.svg')
  const phoneNumber = phone.replace(/-/g, ".")
  const ref = useRef()
  const tooltipEl = useRef(null)

  // const handleCardClick = (event) => {
  //   const card = tooltipEl.current;
  //   const mainLink = card.querySelector('.name > a');
  //   const clickableElements = Array.from(card.querySelectorAll('a, button')).filter((ele) => ele !== mainLink);
  //   const noTextSelected = !window.getSelection().toString();

  //   if (noTextSelected && !clickableElements.includes(event.target)) {
  //       if (event.ctrlKey) {
  //           window.open(mainLink.href, '_blank')
  //       } else {
  //           mainLink.click();
  //       }
  //   }
  // }

  return (
    <div className='map-tooltip' ref={tooltipEl}>
      <div className='tooltip-content'>
        <a href={url}>
          <img className='thumbnail' src={imageUrl} alt={name} />
        </a>
        
        <div className='tooltip-body'>
          <h2 className='name'>
            <a href={url}>{name}</a>
          </h2>
          <p className='address'>{cityStateZip}</p>
          <a className="phone" href={"tel:" + phoneNumber}>{phoneNumber}</a>
          <PriceWrapper 
            startingPrice={startingPrice} 
            isFHA={isFHA} 
            isMortCalcEnabled={isMortCalcEnabled} 
            zipCode={zipCode} 
            downPaymentPercentage={downPaymentPercentage} 
            hoaDues={hoaDues} 
            priceOverrideText={priceOverrideText} 
          />         
        </div>
        <div className='tooltip-footer'>
          <img className='brand-logo' src={company === Brands.CENTURY_COMPLETE ? cmpLogo : ccsLogo} alt='' />
        </div>
      </div>
    </div>
  );
};

export default MapTooltipItem;